import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import {
    Button,
    HorizontalFlex,
    PadContainer,
    AnimatedPageLoader,
} from 'smartsuite-ui';
import { getDataPromise } from 'brock-fetch-utils';
import GroupByDashboard from './GroupByDashboard';
import GroupByMetricSource from './GroupByMetricSource';
import { handleErrorResult } from '../viewDashboards/utils/fetchUtils';
import mapConfigurationVersion from '../viewDashboards/utils/configVersionMappers/mapConfigurationVersion';

// take in props and will have access to uri constants there
export default function DashboardAudit(props) {
    const [isLoading, setIsLoading] = useState(true);
    const { dashboardKey } = useParams();
    const [byDashboard, setByDashboard] = useState(false);

    const [dashboardConfiguration, setDashboardConfiguration] = useState();

    function setError(errorMessage) {
        setDashboardConfiguration((prevDashboardConfiguration) => ({
            ...prevDashboardConfiguration,
            initialStateError: errorMessage,
        }));
    }

    useEffect(() => {
        getDataPromise(
            props.uriConstants.getDashboardConfigurationUri(dashboardKey)
        )
            .then(
                (response) =>
                    setDashboardConfiguration(
                        mapConfigurationVersion(response)
                    ),
                (error) => handleErrorResult(error, setError)
            )
            .then(() => setIsLoading(false));
    }, [props.uriConstants, dashboardKey]);

    if (isLoading) {
        return <AnimatedPageLoader />;
    }

    return (
        <div className="dashboard-audit">
            <PadContainer>
                <HorizontalFlex cssClassModifiers={['space-between']}>
                    <HorizontalFlex>
                        <Button
                            onClick={() => setByDashboard(true)}
                            disabled={byDashboard}
                        >
                            Group By Dashboard
                        </Button>
                        <PadContainer cssClassModifiers={['pad-small']} />
                        <Button
                            onClick={() => setByDashboard(false)}
                            disabled={!byDashboard}
                        >
                            Group By MetricSource
                        </Button>
                    </HorizontalFlex>
                </HorizontalFlex>
                <div>
                    {byDashboard ? (
                        <GroupByDashboard
                            dashboardConfiguration={dashboardConfiguration}
                        />
                    ) : (
                        <GroupByMetricSource
                            dashboardConfiguration={dashboardConfiguration}
                        />
                    )}
                </div>
            </PadContainer>
        </div>
    );
}

DashboardAudit.propTypes = {
    uriConstants: PropTypes.instanceOf(Object).isRequired,
};
